class NikanLogger {
  constructor(level = 0, logOnBuild = false) {

    this.isDevBuild = !(process.env.NODE_ENV && process.env.NODE_ENV === 'production')

    this.base = {
      debug: '[LOGGER DEBUG]',
      log: '[LOGGER LOG]',
      warn: '[LOGGER WARN]',
      error: '[LOGGER ERROR]',
      info: '[LOGGER INFO]',
      force: '[LOGGER FORCE]',
    }

    this.level = level

    this.levels = Object.freeze({
      log: 0,
      debug: 1,
      info: 2,
      warn: 3,
      error: 4,
      off: 99
    })

    this.logOnBuild = logOnBuild
  }

  validate(level, force) {

    if (force)
      return true

    if (!this.isDevBuild && !this.logOnBuild)
      return false

    if (level < this.level)
      return false

    return true
  }

  time(func) {
    console.time()
    func()
    console.timeEnd()
  }

  debug(...messages) {
    if (this.validate(this.levels.debug))
      console.log(this.base.debug, ...messages)
  }

  log(...messages) {
    if (this.validate(this.levels.log))
      console.log(this.base.log, ...messages)
  }

  force(...messages) {
    console.log(this.base.force, ...messages)
  }

  warn(...messages) {
    if (this.validate(this.levels.warn))
      console.warn(this.base.warn, ...messages)
  }

  error(...messages) {
    if (this.validate(this.levels.error))
      console.error(this.base.error, ...messages)
  }

  info(...messages) {
    if (this.validate(this.levels.info))
      console.log(this.base.info, ...messages)
  }

  getCurrentLevel() {
    return this.level
  }

  setLevel(level) {
    this.level = level
  }

  clear() {
    console.clear()
  }

  customHandler(func, level = 0) {
    if (this.validate(level))
      func()
  }
}

const globalLogger = new NikanLogger()
export { globalLogger }
export default NikanLogger